import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import Navigation from './components/Navigation';
import MainTitle from './components/MainTitle';
import DeviceDetector from './components/DeviceDetector';
import AnimatedRoutes from './components/AnimatedRoutes';
import LanguageTransition from './components/CreativeLanguageTransition';
import './i18n/i18n';

const App = () => {
  useEffect(() => {
    // This sets a CSS variable for the viewport height
    // Useful for mobile browsers where the viewport height changes with UI elements
    const setViewportHeight = () => {
      document.documentElement.style.setProperty(
        '--vh',
        `${window.innerHeight * 0.01}px`
      );
    };

    setViewportHeight();
    window.addEventListener('resize', setViewportHeight);

    return () => {
      window.removeEventListener('resize', setViewportHeight);
    };
  }, []);

  return (
    <DeviceDetector>
      <Router>
        <GlobalStyles />
        <MainTitle />
        <Navigation />
        <AnimatedRoutes />
        <LanguageTransition /> {/* Ajout du composant de transition de langue */}
      </Router>
    </DeviceDetector>
  );
};

export default App;